import React from "react";
import { useTranslation } from "react-i18next";
import { SchoolDashboard } from "../../common/api";
import { DataTable, LabelWithTooltip } from "./DashboardStyles";

export const SchoolTeachersTab = ({
  dashboard,
  navigate,
}: {
  dashboard: SchoolDashboard & { is_at_school_level: true };
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  return (
    <DataTable>
      <thead>
        <tr>
          <th scope="col">{t("dashboard_column_teacher_name")}</th>
          <th scope="col">{t("dashboard_column_active_users")}</th>
          <th scope="col">
            <LabelWithTooltip
              tooltip={t("dashboard_column_lessons_completed_tooltip")}
            >
              {t("dashboard_column_lessons_completed")}
            </LabelWithTooltip>
          </th>
        </tr>
      </thead>
      <tbody>
        {dashboard.teacher_sections.map((teacher_section, index) => (
          <tr key={index}>
            <td>
              {teacher_section.teacher_url ? (
                <a
                  href={teacher_section.teacher_url}
                  onClick={() => navigate(teacher_section.teacher_url)}
                >
                  {teacher_section.teacher__first_name}{" "}
                  {teacher_section.teacher__last_name}
                </a>
              ) : (
                <span className="fst-italic">
                  {teacher_section.teacher__first_name}{" "}
                  {teacher_section.teacher__last_name}
                </span>
              )}
            </td>
            <td>{teacher_section.total_count}</td>
            <td>{teacher_section.lessons_completed}</td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  );
};
